import { Clickable } from 'components';
import { theme } from 'lib';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 40px;
  height: 24px;
  background-color: ${(props) => (props.activated ? theme.GREEN : theme.GREY_20)};
  border-radius: 116px;
  position: relative;

  transition: background-color 0.15s linear;
`;

const Ball = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 16px;
  background: #fff;
  position: absolute;
  left: ${(props) => (props.activated ? 20 : 4)}px;
  top: 4px;

  transition: left 0.15s;
`;

const Switch = ({ onClick, activated, label }) => {
  return (
    <Clickable onClick={onClick}>
      <Wrapper activated={activated} role="switch" aria-checked={!!activated} aria-label={label}>
        <Ball activated={activated} />
      </Wrapper>
    </Clickable>
  );
};

export default Switch;
